<template>
    <v-toolbar absolute color="primary">
          <v-spacer></v-spacer>
          <template
            v-for="(item, index) in menu_itens">
            <v-tooltip left :key="index" v-if="item.condicao">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  @click="item.funcao"
                  class="mr-4"
                  color="white"
                  flat
                  dark
                  large
                >
                  <v-icon size="35">{{  item.icon }}</v-icon>
                </v-btn>
              </template>
              {{ item.text }}
            </v-tooltip>
          </template>
          <v-spacer></v-spacer>
      </v-toolbar>
</template>

<script>
export default {
  props: ['menu_itens']
}
</script>
